var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-bottom3",on:{"click":_vm.click}},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-box",staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticClass:"bold"},[_vm._v("피보험자")]),_c('span',{staticClass:"weak"},[_vm._v("자필서명")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-box"},[_c('span',{staticClass:"bold"},[_vm._v("계약자")]),_c('span',{staticClass:"weak"},[_vm._v("자필서명")])])
}]

export { render, staticRenderFns }